module.exports = __webpack_public_path__ + "static/media/RED SMALL BANNER.8de77f40.png";